import { Font } from "@moneyforward/mfx_biz_react_components";
import { Aritcle } from "@/components/atoms/terms/Article";

/**
 * Props for negotiated settlement component
 * @typedef {Object} Props
 * @property {number} articleNumber - The number of the article
 * @property {string} [articleTitle] - The title of the article (optional)
 */
type Props = {
  articleNumber: number;
  articleTitle?: string;
};

/**
 * Component to display negotiated settlement
 */
export const AritcleNegotiatedSettlement: React.FC<Props> = ({
  articleNumber,
  articleTitle = "協議解決",
}: Props) => {
  return (
    <Aritcle articleNumber={articleNumber} articleTitle={articleTitle}>
      <Font>
        当社、利用者及び利用希望者は、本特約に定めのない事項又は本特約の解釈に疑義が生じた場合には、互いに信義誠実の原則に従って協議の上速やかに解決を図るものとします。
      </Font>
    </Aritcle>
  );
};
